import React, { ComponentProps, useMemo, useEffect } from 'react';
import { makeCancelable, CancelablePromise } from 'App/babel/helpers/promise';
import ClientParamResource from 'App/resources/ClientParam';
import AcceptContract from 'App/components/AcceptContract';
import { AITracker } from 'App/babel/helpers/Tracker';
import logError from 'App/babel/helpers/logError';
import T from 'Components/Helpers/translate';
import { Block } from '@upsales/components';
import AppService from 'App/legacy/AppService';

type BlockProps = ComponentProps<typeof Block>;
type Props = BlockProps & { title: string };

const CLIENT_PARAM_ID = 244;

const AcceptAISuggestionContract = ({ title, ...props }: Props) => {
	const self = AppService.getSelf();
	const lang = useMemo(
		() => ({
			title: T(title),
			canNotAcceptText: T('acceptAISuggestionContract.canNotAcceptText')
		}),
		[]
	);

	let clientParamPromise: null | CancelablePromise = null;

	function onAccept() {
		AITracker.track(AITracker.events.ACCEPTED_CONTRACT, {});
		const opts = { skipNotification: true };

		clientParamPromise = makeCancelable(ClientParamResource.save({ id: CLIENT_PARAM_ID, value: true }, opts));
		clientParamPromise.promise.catch(error => {
			console.error(error);
			logError(error);
		});
	}

	useEffect(() => clientParamPromise?.cancel(), []);

	return (
		<AcceptContract
			name={'UpsalesAISuggestions'}
			title={lang.title}
			showAIChip={true}
			canAccept={self?.billingAdmin ?? false}
			canNotAcceptText={lang.canNotAcceptText}
			onAccept={onAccept}
			{...props}
		/>
	);
};

export default AcceptAISuggestionContract;
